export const HomePageConst = {
  TAG_LINE:
    "The future belongs to those who believe in the beauty of their dreams",
    SECOND_SECTION:{
        TITLE:""
    }
};

